var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneytransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_934)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.526 133.755H259.898M388.526 133.755L372.437 111.479M388.526 133.755L372.437 156.004",
    stroke: "black",
    strokeWidth: 13.5629,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.483 367.82H250.039M111.483 367.82L128.813 345.235M111.483 367.82L128.813 390.378",
    stroke: "black",
    strokeWidth: 13.5629,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.532,
    cy: 250.001,
    r: 116.899,
    fill: "#FEF4E8",
    stroke: "#4045A1",
    strokeWidth: 13.5629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25 191.871H295.773V203.182H261.239C261.239 203.182 272.219 214.946 272.219 222.638H295.672V233.044H273.216C273.216 233.044 268.725 268.154 225.708 265.982L278.208 323.264H257.248L204.25 267.974V256.391C204.25 256.391 230.3 257.114 242.775 249.423C252.856 243.18 251.558 239.378 252.456 235.758C252.757 234.401 251.657 233.135 250.16 233.135H204.25V222.728H251.26C252.256 222.728 252.856 221.823 252.357 221.008C250.36 217.48 245.071 209.606 237.786 208.159C228.303 206.35 204.25 205.896 204.25 205.896V191.871Z",
    fill: "#4045A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneytransfer);
export default __webpack_public_path__ + "static/media/money transfer.ce6026bec40e5ef8d2032af05e70445c.svg";
export { ForwardRef as ReactComponent };